<template>
  <div class="inventory_stock_in">
    <b-container fluid>
      <h1>Stock In</h1>
        <b-row class="print-hidden mt-2">
          <b-col>
            <b-form-group label-for="filterCriteria">
              <b-input-group>
                <b-form-input type="text" id="filterCriteria" v-model="filterCriteria" class="form-control" placeholder="Type to search"></b-form-input>
                <b-input-group-append>
                  <b-button @click="cleanFilterInfo()" variant="primary"><b-icon icon="x-circle" variant="white"></b-icon></b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>
        
        <b-button class="print-hidden" variant="primary" @click="showModal('modal-add-stock-in')">Add</b-button>
        
        <b-pagination
          class="my-2"
          v-model="currentPage"
          :page="currentPage"
          :total-rows="rows"
          :per-page="perPage"
          aria-controls="my-table"
        ></b-pagination>

        <b-table
          class="pointer mt-2"
          id="my-table"
          responsive
          striped
          hover
          @row-clicked="myRowClickHandler"
          :fields="fields"
          :filter="filterCriteria"
          :items="displayed_records"
          :per-page="perPage"
          :current-page="currentPage"
          :busy="tableIsBusy"
          small
        >
        
        <template #cell(is_standard)="row">
          <span v-if="row.item.container_number">YES</span>
          <span v-if="!row.item.container_number">NO</span>
        </template>

        </b-table>

      <!-- ADD ITEM -->
      <b-modal size="lg" hide-header-close no-close-on-backdrop id="modal-add-stock-in" hide-footer :title="'Add Stock In'">
        <b-form @submit.prevent="add_stock_in">
          <label for="warehouse_location">Warehosue Location:</label>
          <b-form-select id="warehouse_location"
            v-model="input_location" 
            required
            :options="locations"
          ></b-form-select>

          <label for="item_code">Item Code:</label>
          <b-form-select id="item_code"
            v-model="input_item_code" 
            required
            :options="inventory_item_code_list"
          ></b-form-select>

          <div v-if="!noInvoiceNumberMode">
            <label for="invoice_number">Invoice Number: (Optional, Only for Installation) <b>(Case-sensitive)</b></label>
            <b-form-input id="invoice_number"
              v-model="input_invoice_number"
            ></b-form-input>
          </div>
          
          <!-- <b-input type="text" 
            id="item_code" 
            lazy
            v-model.trim="item_code"
            required></b-input> -->

          <div v-if="itemFetchedByName">

          <label for="date">Date:</label>
          <b-form-datepicker type="text"
            id="date"
            v-model="new_stock_in.date"
            class="form-control"></b-form-datepicker>

          <label for="item_type">Type:</label>
          <p>{{new_stock_in.item_type}}</p>

          <!-- <label for="item_size">Size & Colour:</label>
          <b-form-select id="item_code"
            v-model="size_n_colour_input_add" 
            required
            :options="size_n_colour_input_add_list"
          ></b-form-select> -->
          <!-- <b-input type="text" 
            id="item_size"
            lazy
            v-model.trim="item_size"
            required></b-input> -->

          <!-- <b-input type="text" 
            id="item_colour" 
            lazy
            v-model.trim="item_colour"
            required></b-input> -->

          <label for="item_quantity">Quantity:</label>
          <b-input type="number" 
            id="item_quantity" 
            min="0"
            v-model="new_stock_in.item_quantity" 
            required>
          </b-input>

          <label for="container_number">Container #:</label>
          <b-input type="text" 
            id="container_number" 
            v-model="new_stock_in.container_number" 
            required>
          </b-input>

          <label for="comment">Comment:</label>
          <b-textarea type="text" 
            id="comment" 
            v-model="new_stock_in.comment" 
            rows="2">
          </b-textarea>

          
          <label for="accessory">Accessory Under <b>{{ input_invoice_number }}</b>:</label>
          <div v-for="(order, index) in fetchedAccessoryOrders" :key="'order' + index">

            <div v-for="(item, index) in order.doors" :key="'door' + index">
              <div class="px-2" v-if="item.status != 'arrived'">
                <b-form-checkbox
                  v-model="matchedItemCode"
                  :value="item.itemCode"
                  unchecked-value=""
                >
                {{ item.itemCode }} 
                </b-form-checkbox>
              </div>
            </div>
            <div v-for="(item, index) in order.accessories" :key="'accessory' + index">
              <div class="px-2" v-if="item.status != 'arrived'"> 
                <b-form-checkbox
                  v-model="matchedItemCode"
                  :value="item.itemCode"
                  unchecked-value=""
                >
                {{ item.itemCode }}
                </b-form-checkbox>
              </div>
            </div>
          </div>

          </div>

          <div class="modal-footer mt-4">
            <b-button @click="cancelAddStockIn"> Cancel </b-button>
            <b-button v-if="!itemFetchedByName" variant="primary" @click="fetchItemByName()"> Next </b-button>
            <b-button v-if="itemFetchedByName" type="submit" variant="primary">
              <span v-if="!is_submitting">Add</span>
              <span v-if="is_submitting">
                <b-spinner small type="grow"></b-spinner>
                Submitting...
              </span>
            </b-button>
          </div>
        </b-form>
      </b-modal>

      <!-- VIEW ITEM -->
      <b-modal no-close-on-backdrop :id="'modal-view-stock-in'" hide-footer title="View Stock In">
        <b-form @submit.prevent="update_stock_in">
          <label for="date">Date:</label>
          <b-form-datepicker type="text"
            id="date"
            v-model="viewed_stock_in.date"
            class="form-control"></b-form-datepicker>

          <label for="warehouse_location">Location:</label>
          <p id="warehouse_location">{{viewed_stock_in.location}}</p>

          <label for="item_code">Code:</label>
          <p id="item_code">{{viewed_stock_in.item_code}}</p>

          <!-- <label for="item_size">Size & Colour:</label>
          <p id="item_size">{{viewed_stock_in.item_size + ' ' + viewed_stock_in.item_colour}}</p> -->

          <label for="item_quantity">Quantity:</label>
          <p id="item_colour">{{viewed_stock_in.item_quantity}}</p>
          <!-- <p id="item_code">{{this.viewed_stock_in.item_quantity}}</p> -->

          <label for="container_number">Container #:</label>
          <b-input type="text" 
            id="container_number" 
            v-model="viewed_stock_in.container_number" 
            required></b-input>
          <!-- <p id="item_code">{{this.viewed_stock_in.container_number}}</p> -->

          <label for="comment">Comment:</label>
          <b-textarea type="text" 
            id="comment" 
            v-model="viewed_stock_in.comment" 
            rows="2"></b-textarea>

          <div v-if="viewed_stock_in.matched_invoice_number && viewed_stock_in.matched_invoice_number.length > 0">
            <label for="matched-invoice-number">Matched Invoice Number:</label>
            <p>{{ viewed_stock_in.matched_invoice_number }}</p>
          </div>

          <div v-if="viewed_stock_in.matched_item_code && viewed_stock_in.matched_item_code.length > 0">
            <label for="matched-item-code">Matched Item Code:</label>
            <p>{{ viewed_stock_in.matched_item_code }}</p>
          </div>

          <div class="modal-footer mt-4">
            <b-button @click="showModal('modal-delete-confirmation')" variant="danger">Delete</b-button>
            <b-button @click="hideModal('modal-view-stock-in')"> Close </b-button>
            <b-button type="submit" variant="warning">
              <span v-if="!is_updating">Update</span>
              <span v-if="is_updating">
                <b-spinner small type="grow"></b-spinner>
                Submitting...
              </span>
            </b-button>
          </div>
        </b-form>
      </b-modal>

      <!-- ADD STOCK IN REMINDER -->
      <b-modal
        no-close-on-backdrop
        :id="'modal-add-stock-in-reminder'"
        title="Add Stock In Reminder"
        hide-footer
      >
        <p>Are you sure you want to proceeed without selecting any item under <b>{{ input_invoice_number }}</b>?</p>
        
        <div class="modal-footer mt-1">
          <b-button
            variant="secondary"
            @click="hideModal('modal-add-stock-in-reminder')"
          >
            No
          </b-button>
          <b-button
            :disabled="is_adding_stock_in"
            variant="primary"
            @click="add_stock_in_task()"
          >
            Yes
          </b-button>
        </div>
      </b-modal>

      <!-- DELETE CONFIRMATION -->
      <b-modal
        no-close-on-backdrop
        :id="'modal-delete-confirmation'"
        title="Delete confirmation"
        hide-footer
      >
        <p>This operation will delete a record.</p>
        <p>{{this.viewed_stock_in.item_quantity}} {{this.viewed_stock_in.item_code}} will be removed from {{this.viewed_stock_in.location}} warehouse.</p>
        <div class="modal-footer mt-1">
          <b-button
            variant="secondary"
            @click="hideModal('modal-delete-confirmation')"
          >
            Cancel
          </b-button>
          <b-button
            :disabled="is_deleting"
            variant="danger"
            @click="delete_record()"
          >
            <span v-if="!is_deleting">Delete</span>
            <span v-if="is_deleting">
              <b-spinner small type="grow"></b-spinner>
              Deleting...
            </span>
          </b-button>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import firebase from 'firebase/app'

export default {
  props: {
    user: Object,
  },
  computed: {
    rows: {
      get() {
        if (this.displayed_records.length == 0) {
          return 100;
        } else {
          return this.displayed_records.length;
        }
      },
      set(newRows) {
        return newRows;
      },
    },
  },
  data() {
    return {
      noInvoiceNumberMode: false,
      is_adding_stock_in: false,
      matchedItemCode: "",
      fetchedAccessoryOrders: [],
      fetchedCRMOrder: {},
      input_invoice_number: "",
      size_n_colour_input_add: "",
      size_n_colour_input_add_list: [],
      size_n_colour_input_view: "",
      size_n_colour_input_view_list: [],
      locations: ["DAN", "TH"],
      new_stock_in_sizes: [],
      new_stock_in_colours: [],
      input_location: "",
      input_item_code: "",
      fetchedItem: {},
      itemFetchedByName: false,
      item_code: "",
      item_size: "",
      item_colour: "",
      inventory_item_code_lists: {},
      inventory_item_code_list_dan: [],
      inventory_item_code_list_th: [],
      inventory_item_code_list: [],
      accessory_types: ['Cross', 'Door', 'Decoration', 'Lantern', 'Photo Frame', 'Vase Insert', 'Lid', 'Other'],
      fields: [
        { key: 'date', label: 'Order Date'},
        { key: 'item_type', label: 'Type'}, 
        { key: 'item_code', label: 'Code'},
        { key: 'item_size', label: 'Size'},
        { key: 'item_colour', label: 'Colour'},
        { key: 'item_quantity', label: 'QTY'},
        { key: 'location', label: 'Location'},
        { key: 'container_number', label: 'Container #'},
        { key: 'comment', label: 'Comment'},
        { key: 'creator_name', label: 'Creator'}
      ],
      filterCriteria: "",
      displayed_records: [],
      records: [],
      perPage: 20,
      currentPage: 1,
      tableIsBusy: false,
      new_stock_in: {
        invoice_number: "",
        comment: "",
        container_number: "",
        creator_name: "",
        creator: null,
        date: "",
        id: "",
        item_code: "",
        item_colour: "",
        item_quantity: "",
        item_size: "",
        item_type: "",
        location: "",
        matched_invoice_number: "",
        matched_item_code: "",
      },
      viewed_stock_in: {
        id: "",
        creator: {},
        creator_name: "",
        item_type: "",
        item_code: "",
        item_quantity: "",
        container_number: "",
        location: "",
        date: "",
        comment: "",
      },
      is_submitting: false,
      is_updating: false,
      is_deleting: false,
      today: "",
      origin: {},
    };
  },
  methods: {
    resetInputs() {
      this.input_location = "";
      this.input_item_code = "";
      this.input_invoice_number = "";
      this.matchedItemCode = "";
      this.itemFetchedByName = false;
      this.noInvoiceNumberMode = false;
    },
    cancelAddStockIn() {
      this.resetInputs();

      this.hideModal('modal-add-stock-in');
    },
    fetchItemByName() {
      this.size_n_colour_input_add_list = [];
      this.size_n_colour_input_add = "";
      this.new_stock_in.item_quantity = "";
      this.new_stock_in.container_number = "";
      this.new_stock_in.comment = "";

      this.new_stock_in_sizes = [];
      this.new_stock_in_colours = [];
      if (this.new_stock_in.item_code.length == 0 || this.input_location.length == 0) {
        alert("Please enter item code.");
        return;
      }

      // console.log(this.input_location + this.new_stock_in.item_code);

      firebase.firestore().collection("inventory_test").where("location", "==", this.input_location).where("item_code", "==", this.new_stock_in.item_code).get().then((collection) => {
        this.fetchedItem = collection.docs.map((doc) => doc.data())[0];
        
        console.log(this.fetchedItem);
        
        this.new_stock_in.item_type = this.fetchedItem.item_type;

        for (var i = 0; i < this.fetchedItem.variants.length; i++) {
          this.size_n_colour_input_add_list.push(this.fetchedItem.variants[i].size + ' ' + this.fetchedItem.variants[i].colour + ' Remainning: ' + this.fetchedItem.variants[i].quantity);
        }

        if (this.input_invoice_number.length > 0) {
          firebase.firestore().collection("crm_orders").where("invoiceNumber", "==", this.input_invoice_number).get().then((collection) => {
            this.fetchedCRMOrder = collection.docs.map((doc) => doc.data())[0];

            if (this.fetchedCRMOrder && this.fetchedCRMOrder.accessoryOrders && this.fetchedCRMOrder.accessoryOrders.length > 0) {
              this.fetchedAccessoryOrders = this.fetchedCRMOrder.accessoryOrders;
              this.itemFetchedByName = true;
            } else {
              alert("No matched order under this invoice number. Please check that and make sure it's case is correct.");
            }
          })
        } else {
          this.noInvoiceNumberMode = true;
          this.itemFetchedByName = true;
        }
      });
    },
    myRowClickHandler(item) {
      console.log(item);
      this.viewed_stock_in = Object.assign({}, item);
      // this.origin = Object.assign({}, item);
      this.showModal('modal-view-stock-in');
    },
    cleanFilterInfo() {
      this.filterCriteria = '';
    },
    hideModal(id) {
      this.$bvModal.hide(id);
    },
    showModal(id) {
      this.$bvModal.show(id);
    },
    set_global_date() {
      var date_time = new Date();
      var dd = String(date_time.getDate()).padStart(2, '0');
      var mm = String(date_time.getMonth() + 1).padStart(2, '0'); //January is 0!
      var yyyy = date_time.getFullYear();

      this.today = yyyy + '-' + mm + '-' + dd;
      this.new_stock_in.date = this.today;
    },
    add_stock_in() {
      if (this.matchedItemCode.length == 0) {
        this.showModal("modal-add-stock-in-reminder");
      } else {
        this.add_stock_in_task();
      }
    },
    add_stock_in_task() {
      this.hideModal('modal-add-stock-in-reminder');

      this.is_submitting = true;
      const new_stock_in_ref = firebase.firestore().collection('stock_in_records_test').doc();
      // const inventory_item_code_list_ref = firebase.firestore().collection("parameters").doc("inventory_info");

      this.new_stock_in.id = new_stock_in_ref.id;
      this.new_stock_in.created_date = this.today;
      this.new_stock_in.year_month = this.new_stock_in.created_date.substring(
        0,
        7
      );
      this.new_stock_in.day = parseInt(
        this.new_stock_in.created_date.substring(8, 10)
      );
      //this.new_stock_in.item_code = this.new_stock_in.item_code.toLowerCase().trim();
      this.new_stock_in.creator = this.user;
      this.new_stock_in.creator_name = this.user.name;
      this.new_stock_in.location = this.input_location;

      new_stock_in_ref
        .set(this.new_stock_in, { merge: true })
        .then(() => {
          firebase.firestore()
            .collection("inventory_test")
            .where("location", "==", this.new_stock_in.location)
            .where('item_code', '==', this.new_stock_in.item_code)
            .get().then((collection) => {
            var exisiting_item = collection.docs.map(doc => doc.data())[0];

            exisiting_item.quantity = (parseInt(this.new_stock_in.item_quantity) + parseInt(exisiting_item.quantity)).toString();

            const exisiting_item_ref = firebase.firestore().collection('inventory_test').doc(exisiting_item.id);
            exisiting_item_ref.set(exisiting_item, { merge: true });

            // if (exisiting_items.length > 0) {
            //   exisiting_items.forEach((element) => {
            //     element.item_number_in_stock = parseInt(this.new_stock_in.item_quantity) + parseInt(element.item_number_in_stock);
            //     // console.log(element);
            //     const element_ref = firebase.firestore().collection('inventory_test').doc(element.id);
            //     element_ref.set(element, { merge: true });
            //   });
            // } else {
            //   const new_inventory_item_ref = firebase.firestore().collection('inventory_test').doc();
            //   this.new_stock_in.id = new_inventory_item_ref.id;
            //   new_inventory_item_ref.set(
            //     this.new_stock_in, { merge: true });
            // }

            // this.inventory_item_code_list.push(this.new_stock_in.item_code);
            // inventory_item_code_list_ref.set(this.inventory_item_code_list, { merge: true });
            
            firebase.firestore().collection("crm_orders").where("invoiceNumber", "==", this.input_invoice_number).get().then((collection) => {
              let crmOrder = collection.docs.map((doc) => doc.data())[0];

              console.log(crmOrder.accessoryOrders);

              let item_code = "";
              let email_recipient = crmOrder.sales.email;

              for (let i = 0; i < crmOrder.accessoryOrders.length; i++) {
                for (let d = 0; d < crmOrder.accessoryOrders[i].doors.length; d++) {
                  // console.log(crmOrder.accessoryOrders[i].doors[d].itemCode);
                  if (crmOrder.accessoryOrders[i].doors[d].itemCode == this.new_stock_in.matched_item_code) {
                    crmOrder.accessoryOrders[i].doors[d].status = "arrived";
                    item_code = crmOrder.accessoryOrders[i].doors[d].itemCode;
                  }
                }

                for (let a = 0; a < crmOrder.accessoryOrders[i].accessories.length; a++) {
                  // console.log(crmOrder.accessoryOrders[i].accessories[a].itemCode);
                  if (crmOrder.accessoryOrders[i].accessories[a].itemCode == this.new_stock_in.matched_item_code) {
                    crmOrder.accessoryOrders[i].accessories[a].status = "arrived";
                    item_code = crmOrder.accessoryOrders[i].accessories[a].itemCode;
                  }
                }
              }

              let notification_email = {
                from: "info@johnstonemart.com",
                to: [email_recipient, "Ivy@johnstonemart.com"],
                message: {
                  subject: "#" + crmOrder.invoiceNumber + "/" + item_code + " has arrived.",
                  text: "#" + crmOrder.invoiceNumber + "/" + item_code + " has arrived. \n"
                   + "Warehouse Location: " + this.viewed_stock_in.location + "\n" 
                   + "Comment: " + this.viewed_stock_in.comment + "\n",
                }
              }

              firebase
                .firestore()
                .collection("mail")
                .add(notification_email);

              // console.log(crmOrder);

              const matched_crm_order_ref = firebase.firestore().collection('crm_orders').doc(crmOrder.id);
              matched_crm_order_ref.set(crmOrder, { merge: true });

              this.is_submitting = false;
              this.new_stock_in = {
                invoice_number: "",
                comment: "",
                container_number: "",
                creator_name: "",
                creator: null,
                date: "",
                id: "",
                item_code: "",
                item_colour: "",
                item_quantity: "",
                item_size: "",
                item_type: "",
                location: "",
              };
              
              this.resetInputs();

              alert('Create successfully.');
              this.hideModal('modal-add-stock-in');
            });
          });
        });
    },
    update_stock_in() {
      this.is_updating = true;
      this.viewed_stock_in.item_code = this.viewed_stock_in.item_code.toLowerCase().trim();
      firebase
        .firestore()
        .collection("stock_in_records_test")
        .doc(this.viewed_stock_in.id)
        .set(this.viewed_stock_in, { merge: true })
        .then(() => {
          alert("Modify successfully");
          this.is_updating = false;
        });
    },
    delete_record() {
      this.is_deleting = true;
      firebase
        .firestore()
        .collection("stock_in_records_test")
        .doc(this.viewed_stock_in.id)
        .delete().then(() => {
          firebase.firestore()
            .collection("inventory_test")
            .where("location", "==", this.viewed_stock_in.location)
            .where('item_code', '==', this.viewed_stock_in.item_code)
            .get().then((collection) => {
            var exisiting_item = collection.docs.map(doc => doc.data())[0];

            exisiting_item.quantity = (parseInt(exisiting_item.quantity) - parseInt(this.viewed_stock_in.item_quantity)).toString();

            const exisiting_item_ref = firebase.firestore().collection('inventory_test').doc(exisiting_item.id);
            exisiting_item_ref.set(exisiting_item, { merge: true });
          });

          alert('Delete successfully.');
          this.is_deleting = false;
          this.hideModal('modal-view-stock-in');
          this.hideModal('modal-delete-confirmation');
        });
    },
  },
  created() {
    this.set_global_date();

    firebase.firestore().collection("stock_in_records_test").orderBy('date', "desc").onSnapshot((collection) => {
      this.records = [];
      this.records = collection.docs.map(doc => doc.data());
      this.displayed_records = this.records;
    });

    firebase.firestore().collection("inventory_test").orderBy('item_code', "asc").onSnapshot((collection) => {
      let items = collection.docs.map(doc => doc.data());
      for (let i = 0; i < items.length; i++) {
        if (this.inventory_item_code_lists[items[i].location] == null) {
          this.inventory_item_code_lists[items[i].location] = []
        }
        this.inventory_item_code_lists[items[i].location].push(items[i].item_code);
      }
      console.log(this.inventory_item_code_lists);
    });

    // firebase.firestore().collection("parameters").doc("inventory_info").get().then((doc) => {
    //   this.inventory_item_code_list_dan = doc.data().inventory_item_code_list_dan;
    //   this.inventory_item_code_list_th = doc.data().inventory_item_code_list_th;
    // });

  },
  watch: {
    input_invoice_number(newinput_invoice_number) {
      this.new_stock_in.matched_invoice_number = newinput_invoice_number;
    },
    matchedItemCode(newmatchedItemCode) {
      // let item_code = newmatchedItemCode.split('_')[0];
      // let mode = newmatchedItemCode.split('_')[1];
      this.new_stock_in.matched_item_code = newmatchedItemCode;
      // alert(newmatchedItemCode);
      // alert(this.new_stock_in.matched_item_code);
    },
    size_n_colour_input_add(new_size_n_colour_input_add) {
      if (new_size_n_colour_input_add.length > 0) {
        const words = new_size_n_colour_input_add.split(' ');
        this.new_stock_in.item_size = words[0];
        this.new_stock_in.item_colour = words[1];
      }
    },
    item_colour(new_item_colour) {
      this.item_colour = new_item_colour.charAt(0).toUpperCase() + new_item_colour.slice(1).toLowerCase();
      this.new_stock_in.item_colour = this.item_colour;
    },
    item_size(new_item_size) {
      this.item_size = new_item_size.toLowerCase();
      this.new_stock_in.item_size = this.item_size;
    },
    input_location(new_input_location) {
      this.new_stock_in.item_code = "";
      this.itemFetchedByName = false;

      this.inventory_item_code_list = this.inventory_item_code_lists[new_input_location];
    },
    input_item_code(new_item_code) {
      this.itemFetchedByName = false;
      this.new_stock_in.item_code = new_item_code
    }
  },
}
</script>